<template>
  <section class="table devices">
    <header>
      <div class="column deviceNumber" @click="sortByColumn('deviceNumber')">
        <div>#</div>
        <SortArrow v-if="columnSortedBy.deviceNumber.display" v-bind:ascending="sortByAscending" />
      </div>

      <div class="column deviceType" @click="sortByColumn('deviceType')">
        <div>Type</div>
        <SortArrow v-if="columnSortedBy.deviceType.display" v-bind:ascending="sortByAscending" />
      </div>

      <div class="column device" @click="sortByColumn('manufacturer', 'model')">
        <div>Device</div>
        <SortArrow v-if="columnSortedBy.manufacturer.display" v-bind:ascending="sortByAscending" />
      </div>

      <div class="column os" @click="sortByColumn('os', 'version')">
        <div>OS</div>
        <SortArrow v-if="columnSortedBy.os.display" v-bind:ascending="sortByAscending" />
      </div>

      <div class="column notes" @click="sortByColumn('notes')">
        <div>Notes</div>
        <SortArrow v-if="columnSortedBy.notes.display" v-bind:ascending="sortByAscending" />
      </div>

      <div class="column actions"></div>
    </header>

    <div class="row device" v-for="device in filteredDevices" :key="device.key">
      <div class="column deviceNumber" :id="'deviceNumber' + device.key">{{device.deviceNumber}}</div>
      <div class="column deviceType" :id="'deviceType' + device.key">
        <AndroidPhone v-if="device.deviceType === 'phone' && device.os === 'android'" />
        <ApplePhone v-if="device.deviceType === 'phone' && device.os === 'iOS'" />
        <AndroidTablet v-if="device.deviceType === 'tablet' && device.os === 'android'" />
        <AppleTablet v-if="device.deviceType === 'tablet' && device.os === 'iOS'" />
      </div>
      <div class="column device" :id="'manufacturer' + device.key">{{`${device.manufacturer} ${device.model}`}}</div>
      <div class="column os" v-bind:class="{ 'capitalize': device.os === 'android' }" :id="'os' + device.key">{{`${device.os} ${device.version}`}}</div>
      <div class="column notes" :id="'notes' + device.key">{{device.notes}}</div>
      <div
        class="column actions"
        @click="$emit('display-edit-device-dialog', device)"
      >
        <EditPencil />
      </div>
    </div>

  </section>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/database'
import SortArrow from '@/components/assets/SortArrow.vue'
import EditPencil from '@/components/assets/EditPencil.vue'
import { snapshotToArray } from '../../utilities/firebase.utilities';
import { sortBy } from '../../utilities/array.utilities';
import { sortByMultiple } from '../../utilities/array.utilities';
import AndroidLogo from '@/components/assets/AndroidLogo';
import AppleLogo from '@/components/assets/AppleLogo';
import AndroidPhone from '@/components/assets/AndroidPhone';
import AndroidTablet from '@/components/assets/AndroidTablet';
import ApplePhone from '@/components/assets/ApplePhone';
import AppleTablet from '@/components/assets/AppleTablet';

export default {
  name: 'DeviceList',
  props: ['searchText'],
  components: {
    AndroidPhone,
    AndroidTablet,
    ApplePhone,
    AppleTablet,
    AppleLogo,
    AndroidLogo,
    EditPencil,
    SortArrow
  },
  created() {
    this.getDevices()
  },
  data() {
    return {
      devices: [],
      columnSortedBy: {
        deviceNumber: { display: true, ascending: true },
        deviceType: { display: false, ascending: true },
        manufacturer: { display: false, ascending: true },
        model: { display: false, ascending: true },
        os: { display: false, ascending: true },
        version: { display: false, ascending: true },
        notes: { display: false, ascending: true }
      },
      sortByAscending: true
    }
  },
  computed: {
    filteredDevices() {
      return this.devices.filter((device) => {
        return this.searchTextIncludes(device.manufacturer) ||
          this.searchTextIncludes(device.model) ||
          this.searchTextIncludes(device.deviceNumber) ||
          this.searchTextIncludes(device.deviceType) ||
          this.searchTextIncludes(device.os) ||
          this.searchTextIncludes(device.version)
      })
    }
  },
  methods: {
    getDevices() {
      const query = firebase.database().ref('devices')
      query.on('value', (res) => {
        this.devices = snapshotToArray(res)
        this.devices = sortBy(this.devices, 'deviceNumber')
      })
    },
    sortByColumn(columnName, secondColumnName) {
      if (this.columnSortedBy[columnName].display) this.toggleSortByAscending()

      for (let prop in this.columnSortedBy) {
        this.columnSortedBy[prop].display = (prop === columnName);
      }

      if (secondColumnName) {
        this.devices = sortByMultiple(this.devices, columnName, secondColumnName, this.sortByAscending)
      } else {
        this.devices = sortBy(this.devices, columnName, this.sortByAscending)
      }
    },
    toggleSortByAscending() {
      this.sortByAscending = !this.sortByAscending
    },
    searchTextIncludes(deviceColumn) {
      return deviceColumn.toLowerCase().includes(this.searchText.toLowerCase())
    }
  }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
@import '../../assets/styles/mixin';
@import '../../assets/styles/colors';
@import '../../assets/styles/tables';

.deviceNumber {
  flex-basis: 5%;
}

.version {
  flex-basis: 8%;
}

.deviceType {
  flex-basis: 6%;
}

.os {
  flex-basis: 14%;
}

.device {
  flex-basis: 25%;
}

.notes {
  flex-basis: 39%;
}
</style>



// WEBPACK FOOTER //
// src/components/device/DeviceList.vue